module.exports = __webpack_public_path__ + "media/images/avatar/23-eebe0cd0cd882cf27b0b3086124155c7.svg";